import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/JwtService";
import { number } from "yup";
/**
 * @description service to call HTTP request via Axios
 */
class chmService {
    /**
     * @description initialize vue axios
     */
    static init(app) {
        chmService.vueInstance = app;
        if (!chmService.vueInstance.axios)
            chmService.vueInstance.use(VueAxios, axios);
        chmService.BaseUrl = import.meta.env.VITE_CHM_URL;
    }
    /**
     * @description set the default HTTP request headers
    */
    static setHeader() {
        chmService.vueInstance.axios.defaults.headers.common["Authorization"] = "Bearer " + JwtService.getToken();
        chmService.vueInstance.axios.defaults.headers.common["Accept"] =
            "application/json";
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static query(resource, params) {
        return chmService.vueInstance.axios.get(`${chmService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static get(resource, slug = "") {
        return chmService.vueInstance.axios.get(`${chmService.BaseUrl}/${resource}/${slug}`);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static getStream(resource, slug = "") {
        return chmService.vueInstance.axios.get(`${chmService.BaseUrl}/${resource}/${slug}`, {
            responseType: 'stream'
        });
    }
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static post(resource, params) {
        return chmService.vueInstance.axios.post(`${chmService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description Método para enviar arquivos (planilhas) como FormData
     * @param resource: string
     * @param formData: FormData
     * @returns Promise<AxiosResponse>
     */
    static postFile(resource, formData, params) {
        let header = '';
        if (params) {
            header = Object.keys(params).reduce((acc, curr, index) => {
                if (index == 0)
                    acc += `?${curr}=${params[curr]}`;
                else
                    acc += `&${curr}=${params[curr]}`;
                return acc;
            }, '');
        }
        return chmService.vueInstance.axios.post(`${chmService.BaseUrl}/${resource}${header}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data' // Cabeçalho necessário para envio de arquivos
            }
        });
    }
    static getFile(resource, slug = "") {
        return chmService.vueInstance.axios.get(`${chmService.BaseUrl}/${resource}/${slug}`, {
            responseType: 'blob', // Isso garante que o conteúdo retornado seja tratado como arquivo binário
        });
    }
    /**
    * @description Send the PUT HTTP request
    * @param resource: string
    * @param params: AxiosRequestConfig
    * @returns Promise<AxiosResponse>
    */
    static put(resource, params) {
        return chmService.vueInstance.axios.put(`${chmService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the DELETE HTTP request
    * @param resource: string
    * @param slug: number
    * @returns Promise<AxiosResponse>
    */
    static delete(resource, slug = number) {
        return chmService.vueInstance.axios.delete(`${chmService.BaseUrl}/${resource}/${slug}`);
    }
    /**
    * @description set the POST HTTP request
    * @param resource: string
    * @param params: AxiosRequestConfig
    * @returns Promise<AxiosResponse>
    */
    static postForm(resource, params) {
        return chmService.vueInstance.axios.post(`${chmService.BaseUrl}/${resource}`, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}
export default chmService;
//# sourceMappingURL=chmService.js.map